module.exports = __webpack_public_path__ + "img/video-cover.ff623124.png";